import FormattedInvoicePropertyLabelAndValue from 'invoices-ui-lib/components/FormattedInvoicePropertyLabelAndValue';
import { getInvoiceProperty } from 'invoices-ui-lib/utils/property';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InvoiceHighlightDetails = ({
  invoice,
  propertyDefinitions
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: "text-left m-y-4",
    children: [/*#__PURE__*/_jsx("h3", {
      className: "m-bottom-2",
      "data-test-id": `invoices-preview-header-${invoice.objectId}`,
      children: /*#__PURE__*/_jsx(FormattedInvoicePropertyLabelAndValue, {
        "data-test-id": "invoice-highlight-header-content",
        invoice: invoice,
        propertyDefinitions: propertyDefinitions,
        propertyName: "hs_number",
        displayLabel: false
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "m-bottom-1",
      children: /*#__PURE__*/_jsx(FormattedInvoicePropertyLabelAndValue, {
        "data-test-id": "invoice-highlight-amount-billed-content",
        invoice: invoice,
        propertyDefinitions: propertyDefinitions,
        propertyName: "hs_amount_billed"
      })
    }), /*#__PURE__*/_jsx("div", {
      "data-test-id": `invoice-status-${getInvoiceProperty(invoice, 'hs_invoice_status')}`,
      className: "m-bottom-1",
      children: /*#__PURE__*/_jsx(FormattedInvoicePropertyLabelAndValue, {
        "data-test-id": "invoice-highlight-status-content",
        invoice: invoice,
        propertyDefinitions: propertyDefinitions,
        propertyName: "hs_invoice_status"
      })
    })]
  });
};
export default InvoiceHighlightDetails;